module.exports = __webpack_public_path__ + "img/logop2.ffabc099.png";